import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRuler = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.63629 14.1238L7.0505 15.538M8.46472 11.2953L9.87893 12.7096M11.2931 8.46691L12.7074 9.88113M14.1216 5.63849L15.5358 7.0527M2.80786 16.9522L7.0505 21.1948L21.1926 7.0527L16.95 2.81006L2.80786 16.9522Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRuler;
